import { render, staticRenderFns } from "./TestResult.vue?vue&type=template&id=033d0ff8&"
import script from "./TestResult.vue?vue&type=script&lang=js&"
export * from "./TestResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('033d0ff8')) {
      api.createRecord('033d0ff8', component.options)
    } else {
      api.reload('033d0ff8', component.options)
    }
    module.hot.accept("./TestResult.vue?vue&type=template&id=033d0ff8&", function () {
      api.rerender('033d0ff8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/TestForm/components/TestResult/TestResult.vue"
export default component.exports